import React from 'react';

export default function RecommendProductListWrapper({
  currentSelectedRecommendProduct,
  children,
}: {
  currentSelectedRecommendProduct: string;
  children: React.ReactElement;
}) {
  if (!currentSelectedRecommendProduct) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '40px 0',
          color: 'rgba(0, 0, 0, 0.85)',
          fontSize: '14px',
        }}
      >
        请先选择左侧推荐商品，系统将按照您选择的商品展示速采清单
      </div>
    );
  }

  return children;
}
